import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useStyles } from '~/views/molecules/dialog-buttons/styles';
import { IconButton } from '@mui/material';
import { RightArrow } from '~/views/atoms/svg-icons';
export const RightArrowButton = ({ rightArrowButtonHandler, disabled }) => {
    const classes = useStyles();
    return (_jsx(IconButton, { disabled: disabled, className: classes.button, onClick: rightArrowButtonHandler, children: _jsx(RightArrow, { fill: "primary", color: "primary" }) }));
};
